export let ApprovalOperation;
(function (ApprovalOperation) {
  ApprovalOperation["REQUEST"] = "REQUEST";
  ApprovalOperation["APPROVE"] = "APPROVE";
  ApprovalOperation["CANCEL"] = "CANCEL";
  ApprovalOperation["RECALL"] = "RECALL";
  ApprovalOperation["REJECT"] = "REJECT";
})(ApprovalOperation || (ApprovalOperation = {}));